import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0bd76cd3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.89.0__lodash@4.18.1_prettier@2.8.8_twig@1_5816a434900cfed2b1d7b77d38625343/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports